import { ContentProps } from 'types';
import { LayoutContainerContentProps } from './types';

const isLayoutContainer = (content: unknown): content is LayoutContainerContentProps =>
  (content as ContentProps).componentName === 'layout_container';

export default isLayoutContainer;
